import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import BaseService from "./baseService";
import { MethodRequest } from "@/enum/method";

export type Pagination = {
    limit: number;
    page: number;
    totalPages: number;
}

export type IReponse<T> = {
    data: T;
    statusCode: number;
    success: boolean;
    pagination: Pagination;
    last_page?: number;
    current_page?: number;
}

function makeRequest<Response = unknown, Request = Record<string, unknown>>(param: AxiosRequestConfig<Request>) {
    return new Promise<IReponse<Response>>((resolve, reject) => {
        BaseService(param)
            .then((response: AxiosResponse) => {
                resolve(response.data)
            })
            .catch((errors: AxiosError) => {
                reject(errors)
            })
    })
}

function getService<T = unknown>(param: AxiosRequestConfig) {
    return makeRequest<T>({ method: MethodRequest.Get, ...param })
}

function postService<T = unknown>(param: AxiosRequestConfig) {
    return makeRequest<T>({ method: MethodRequest.Post, ...param })
}

function putService<T = unknown>(param: AxiosRequestConfig) {
    return makeRequest<T>({ method: MethodRequest.Put, ...param })
}

function deleteService<T = unknown>(param: AxiosRequestConfig) {
    return makeRequest<T>({ method: MethodRequest.Delete, ...param })
}

export { getService, postService, putService, deleteService, makeRequest }